export function makeid(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
export const create = (state, workflow, cb) => {
  workflow.id = makeid(16);
  state[workflow.id] = workflow;
  cb(workflow);
  return state;
};

export const update = (state, workflow, cb) => {
  state[workflow.id] = workflow;
  return state;
};

export const _delete = (state, workflow) => {
  delete state[workflow.id];
  return state;
};

export const insert = (state, workflow, action) => {
  const _workflow = JSON.parse(JSON.stringify(workflow));
  _workflow.actions.push(action);
  state[_workflow.id] = _workflow;
  return state;
};
export const deleteAction = (state, workflow, index) => {
  const _workflow = JSON.parse(JSON.stringify(workflow));
  _workflow.actions.splice(index, 1);
  state[_workflow.id] = _workflow;
  return state;
};
export const updateAction = (state, workflow, action, index) => {
  const _workflow = JSON.parse(JSON.stringify(workflow));
  _workflow.actions.splice(index, 1, action);
  state[_workflow.id] = _workflow;
  return state;
};

export const moveAction = (state, workflow, fromIndex, toIndex) => {
  const _workflow = JSON.parse(JSON.stringify(workflow));

  if (fromIndex > toIndex) {
    //remove then insert
    const action = _workflow.actions[fromIndex];
    _workflow.actions.splice(fromIndex, 1);
    _workflow.actions.splice(toIndex + 1, 0, action);
  } else {
    //insert then remove
    const action = _workflow.actions[fromIndex];
    _workflow.actions.splice(toIndex + 1, 0, action);
    _workflow.actions.splice(fromIndex, 1);
  }
  state[_workflow.id] = _workflow;
  return state;
};
